import { USER_REQUIREMENT_REF_PREFIX } from './requirementRef.util'

// "user:<upn>" is this domain's own sentinel prefix — distinct from group requirements'
// "group:<id>", named location requirements' "location:<id>", and application requirements'
// "application:<id>" — so a raw policyBody value is unambiguous about which kind of requirement
// it diverts to, without needing to know which field it came from.
export const REQUIREMENT_REF_PREFIX = USER_REQUIREMENT_REF_PREFIX

export const isRequirementRef = (value) => typeof value === 'string' && value.startsWith(REQUIREMENT_REF_PREFIX)

export const getRequirementId = (value) => (isRequirementRef(value) ? value.slice(REQUIREMENT_REF_PREFIX.length) : null)

export const toRequirementRef = (requirementId) => `${REQUIREMENT_REF_PREFIX}${requirementId}`

// Graph sentinels for a users condition — never directory object ids, so never looked up or
// turned into a requirement. Shared by every place that needs to tell a built-in selector apart
// from a source-tenant user id: CreatePolicyTemplatePanel (copying a policy), convertPolicyToTemplate
// (importing a baseline), and useUserFieldRequirements (authoring a template's field value).
export const BUILT_IN_USER_VALUES = new Set(['All', 'None', 'GuestsOrExternalUsers'])

// Mirrors backend/src/lambdas/service/hub/microsoft/userRequirements/resolveUserRequirements.js's
// RESOLUTION_STATUS. No MULTI_MATCH status exists here — userPrincipalName is unique within a
// tenant, so a UPN either matches exactly one user or none. No CREATABLE status exists either —
// Augmentt never creates or invites users, so a requirement that finds no match is unresolvable.
export const USER_REQUIREMENT_STATUS = {
  MATCHED: 'matched',
  UNRESOLVABLE: 'unresolvable',
  LOOKUP_FAILED: 'lookupFailed',
}
